<template>
  <div class="h-100 d-flex justify-content-center align-items-center align-middle">
    <div class="row">
      <div class="col-12 text-center">
        <h1>Configuration manquante ou invalide</h1>
        <a class="mx-auto btn btn-primary mt-4" :href="$store.state.fallbackTokenUrl">
          Recharger la page
        </a>
      </div>
    </div>
  </div>
</template>

<script>
export default {
  name: 'MissingConfiguration',
  computed: {
    errors() {
      const out = [];
      if (this.$store.state.path === '') out.push("Parametre 'path' manquant");
      if (this.$store.state.tokenId === '') out.push("Parametre 'tokenID' manquant");
      return out;
    },
  },
};
</script>

<style scoped></style>
